import Auth from '@/modules/auth/models/Auth'
import Config from '@/modules/config/models/Config'

export default {
  namespaced: true,
  state: {
    refreshTokenPromise: null // Holds the promise of the refresh token
  },
  mutations: {
    refreshTokenPromise(state, promise) {
      state.refreshTokenPromise = promise
    }
  },
  actions: {
    async me({ _dispatch }, type) {
      try {
        // if (type == 'users') type = 'individuals'
        if (type == 'users') type = 'students'
        let me = {}
        if (type) {
          me = await this._vm.$axios.get(`/api/${type}/me`)
        } else {
          me = await this._vm.$axios.get('/api/me')
        }
        Auth.insert({ data: me }, { root: true })

        return me
      } catch (error) {
        throw error
      }
    },
    async logout({ _dispatch }, type) {
      if (type == 'users') type = 'students'
      await this._vm.$axios.delete(`/api/${type}/logout`)
      Auth.delete(user => {
        return user.type === type
      })
    },

    async updateProfile({ _dispatch }, { type, payload }) {
      if (type == 'users') {
        type = 'students'
      }
      if (Config.value('isSDECC') == 1) {
        payload.isSDECC = 1
      }
      try {
        const me = await this._vm.$axios.patch(`/api/${type}/profile`, payload)
        if (Config.value('isSDECC') == 1) {
          const meSDECC = await this._vm.$axios.get(`/api/${type}/me`)
          Auth.update({ data: meSDECC }, { root: true })
        } else {
          Auth.update({ data: me }, { root: true })
        }
      } catch (error) {
        throw error
      }
    },
    async resetActivity({ _dispatch }, type) {
      if (type == 'users') type = 'students'
      try {
        await this._vm.$axios.get(`/api/${type}/reset-activity`)
      } catch (error) {
        throw error
      }
    },
    refreshToken({ commit, state }, type) {
      // If this is the first time the refreshToken has been called, make a request
      // otherwise return the same promise to the caller
      if (type == 'users') type = 'students'
      if (!state.refreshTokenPromise) {
        const accessTokenPromise = this._vm.$axios.post(
          `/api/${type}/oauth/token/`,
          {
            type: 'refresh'
          }
        )
        commit('refreshTokenPromise', accessTokenPromise)

        // Wait for the refreshToken service to resolve. On success set the token and clear promise
        // Clear the promise on error as well.
        accessTokenPromise.then(
          response => {
            commit('refreshTokenPromise', null)
            return response
          },
          error => {
            commit('refreshTokenPromise', null)
            return error
          }
        )
      }

      return state.refreshTokenPromise
    }
  }
}
